// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__PAWaH","head":"styles_head__CH0dG","buttonGroup":"styles_buttonGroup__jNVQ5","button":"styles_button__cXK0L","buttonTabs":"styles_buttonTabs__eDHvZ"};